import React from 'react';
import androidImg from './assets/2pcandroid.png';
import { FaDownload, FaDiscord, FaYoutube } from 'react-icons/fa';
import './Dashboard.css';
import { useTranslation } from 'react-i18next';

const MobileDashboard = ({ productKey, keyStatus, expiryValue, downloadLink, apkDownloadLink }) => {
  const { t } = useTranslation();
  const isActive = keyStatus === "activated";

  let expiryDisplay = null;
  if (keyStatus === "activated") {
    const totalSeconds = parseInt(expiryValue, 10);
    const days = Math.floor(totalSeconds / (3600 * 24));
    let remainder = totalSeconds % (3600 * 24);
    const hours = Math.floor(remainder / 3600);
    remainder %= 3600;
    const minutes = Math.floor(remainder / 60);
    const seconds = remainder % 60;

    expiryDisplay = (
      <p>
        <span style={{ fontWeight: 'bold' }}>{t('dashboard_expires_in')}</span>{' '}
        <span className="highlight-green">{days}</span>{' '}
        <span style={{ color: 'white' }}>{t('dashboard_days')}</span>{' '}
        <span className="highlight-green">{hours}</span>{' '}
        <span style={{ color: 'white' }}>{t('dashboard_hours')}</span>{' '}
        <span className="highlight-green">{minutes}</span>{' '}
        <span style={{ color: 'white' }}>{t('dashboard_minutes')}</span>{' '}
        <span className="highlight-green">{seconds}</span>{' '}
        <span style={{ color: 'white' }}>{t('dashboard_seconds')}</span>
      </p>
    );
  } else {
    expiryDisplay = (
      <p style={{ color: 'white' }}>
        {t('dashboard_valid_for')} <span className="highlight-green">{expiryValue}</span>{' '}
        <span style={{ color: 'white' }}>{t('dashboard_days')}</span>{' '}
        {t('dashboard_after_activation')}
      </p>
    );
  }

  return (
    <div className="dashboard-page">
      <div className="dashboard-container">
        <h1>{t('dashboard_heading')}</h1>

        <p>
          <span style={{ fontWeight: 'bold' }}>{t('dashboard_your_key')}</span>{' '}
          <span className="highlight-green">{productKey}</span>
        </p>

        <p>
          <span style={{ fontWeight: 'bold' }}>{t('dashboard_status')}</span>{' '}
          <span className={isActive ? 'status-active' : 'status-inactive'}>
            {t(`dashboard_status_value_${keyStatus}`) /* e.g. 'activated' or 'pending' translation */}
          </span>
        </p>

        {expiryDisplay}

        <div className="dashboard-buttons" style={{ flexWrap: 'wrap' }}>
          <a
            href={apkDownloadLink}
            target="_blank"
            rel="noopener noreferrer"
            className="dashboard-button download-button"
          >
            <FaDownload className="icon" />
            <span>Download App</span>
          </a>
          <a
            href={downloadLink}
            target="_blank"
            rel="noopener noreferrer"
            className="dashboard-button download-button"
          >
            <FaDownload className="icon" />
            <span>Download NIS</span>
          </a>
          <a
            href="https://youtu.be/t4YOfdqBrhs"
            target="_blank"
            rel="noopener noreferrer"
            className="dashboard-button tutorial-button"
          >
            <FaYoutube className="icon" />
            <span>Setup Tutorial</span>
          </a>
          <a
            href="https://discord.com/invite/zEeq3jTzAR"
            target="_blank"
            rel="noopener noreferrer"
            className="dashboard-button support-button"
            style={{ fontSize: '14px', padding: '8px 16px' }}
          >
            <FaDiscord className="icon" />
            <span>{t('dashboard_discord_support')}</span>
          </a>
        </div>
        {/* Bild unterhalb der Buttons */}
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <img src={androidImg} alt="Android App" style={{ maxWidth: '80%', height: 'auto' }} />
        </div>
      </div>
    </div>
  );
};

export default MobileDashboard;
